export { default as StrategyProfileMetricItem } from './StrategyProfileMetricItem';
